import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const APPEAL_LETTER_ROWS = 14;
const APPEAL_LETTER_MAX_ROWS = 40;
export default /*@__PURE__*/ _defineComponent({
    __name: 'OutgoingContentField',
    props: {
        modelValue: { default: "" },
        label: {},
        appeal: { type: Boolean, default: false }
    },
    emits: ["update:modelValue"],
    setup(__props, { emit: __emit }) {
        const emit = __emit;
        return (_ctx, _cache) => {
            const _component_v_textarea = _resolveComponent("v-textarea");
            return (_openBlock(), _createBlock(_component_v_textarea, {
                "model-value": __props.modelValue,
                label: __props.label,
                "auto-grow": __props.appeal,
                rows: __props.appeal ? APPEAL_LETTER_ROWS : undefined,
                "max-rows": __props.appeal ? APPEAL_LETTER_MAX_ROWS : undefined,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = (value) => emit('update:modelValue', value))
            }, null, 8, ["model-value", "label", "auto-grow", "rows", "max-rows"]));
        };
    }
});
